import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatDialog } from "@angular/material/dialog";
import { MatSort } from "@angular/material/sort";
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PrefectureTableData } from "../../models/pfepModels";
import { logbaseService } from "../../services/logbase.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";
import { FormBuilder } from "@angular/forms";
import { PrefecturesPopupComponent } from "../../common/prefectures-popup/prefectures-popup.component";

@Component({
  selector: "app-prefectures",
  templateUrl: "./prefectures.component.html",
  styleUrls: ["./prefectures.component.scss"]
})
export class PrefecturesComponent implements OnInit,AfterViewInit {
  displayedColumns = [
    // "select",
    "prefecture",
    "cityName",
    "region",
    "edit",
    "delete"
  ];
  dataSource = new MatTableDataSource<PrefectureTableData>();
  pageSize = 10;
  pageSizeOptions = [10, 20, 30, 50, 100];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild("prefecturePage") prefecturePage: ElementRef;
  @ViewChild("prefectureInput") prefectureInput: ElementRef;
  length = 0;
  constructor(
    public snackBar: MatSnackBar,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private router: Router,
    private logbaseService: logbaseService,
    private spinner: NgxSpinnerService
  ) {}
  ngOnInit() {
    this.dataSource.sort = this.sort;
    this.getPrefecturesTableData();
  }
 

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getPrefecturesTableData() {
    const initialObj = {
      pageNo: 0,
      pageSize: this.pageSize
    };
    this.spinner.show();
    this.logbaseService.getAllPrefectures().subscribe(
      response => {
        const prefecData = response;
        if (
          prefecData.status.statusMessage === "SUCCESS" &&
          prefecData.status.statusCode === 1 &&
          prefecData.response !== "Response is empty"
        ) {
          // console.log(prefecData.response, prefecData.status);
          this.spinner.hide();
          this.length = prefecData.response.length;
          this.dataSource = new MatTableDataSource<PrefectureTableData>(
            prefecData.response
          );
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        } else {
          this.spinner.hide();
        }
        // console.log(prefecData.status);
      },
      error => {
        this.spinner.hide();
      }
    );
  }

  openAddPrefecture() {
    let dialogRef = this.dialog.open(PrefecturesPopupComponent, {
      minWidth: "auto",
      maxWidth: "97vw",
      disableClose: true,
      data: { type: "AddPrefecData" }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getPrefecturesTableData();
      dialogRef.close();
    });
  }

  editPrefecture(prefec) {
    let dialogRef = this.dialog.open(PrefecturesPopupComponent, {
      minWidth: "auto",
      maxWidth: "97vw",
      disableClose: true,
      data: { type: "EditPrefecData", prefecData: prefec }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getPrefecturesTableData();
      dialogRef.close();
    });
  }

  deletePrefecture(prefec) {
    let dialogRef = this.dialog.open(PrefecturesPopupComponent, {
      minWidth: "auto",
      maxWidth: "97vw",
      disableClose: true,
      data: { type: "DeletePrefecData", prefecData: prefec }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getPrefecturesTableData();
      dialogRef.close();
    });
  }

  handlePrefecturePage(event, totalData) {
    console.log(event, totalData);
    // // const searchObj = {
    // //   'buildingNos': this.buildingsArr,
    // //   'code': this.rackCodeInput.nativeElement.value,
    // //   'pageNo': event.pageIndex,
    // //   'pageSize': event.pageSize,
    // // };
    // this.pageSize = event.pageSize;
    // this.pfepService.getRackData(searchObj).subscribe(response => {
    //   const rackData = response.result;
    //   if (response.status && response.status.statusCode === 200) {
    //     this.length = response.result.totalCount;
    //     this.downloadRackData = response.result.data;
    //     this.dataSource = new MatTableDataSource<RackTableData>(response.result.data);
    //   }
    // }, error => {
    //   this.spinner.hide();
    // });
  }
}
